import { createEffect } from "solid-js"
import { PerspectiveCamera } from "three"
import { getDeviceUserPreference } from "../../../rx/shared/device/userPreference/deviceUserPreferencesSignal"
import type { Engine } from "../../core/engine/Engine.type"
import { getEngineThreeMainCamera } from "../fn/getSetEngineThreeMainCamera"

export default function bindCameraToUserPreferences(
  engine: Engine,
) {
  createEffect(() => {
    // console.log('bindCameraToUserPreferences.effect')
    const camera = getEngineThreeMainCamera(engine)
    if (camera instanceof PerspectiveCamera) {
      const prefs = getDeviceUserPreference()
      camera.far = prefs.camera_far
      camera.fov = prefs.camera_fov
      camera.updateProjectionMatrix()
    }
  })
  // createMountedInverval(() => {
  //   const newValue = PERSPECTIVE_CAMERA_FAR_MIN
  //     + (Math.random() * (PERSPECTIVE_CAMERA_FAR_MAX - PERSPECTIVE_CAMERA_FAR_MIN))
  //   updateCameraFar(floor(newValue))
  // }, 3000)
}
